module.exports = __webpack_public_path__ + "img/ic_export-mapping.3d7baf5c.svg";